import { render } from "./NewUsersComponent.vue?vue&type=template&id=0d7e0f7c&scoped=true"
import script from "./NewUsersComponent.vue?vue&type=script&lang=js"
export * from "./NewUsersComponent.vue?vue&type=script&lang=js"

import "./NewUsersComponent.vue?vue&type=style&index=0&id=0d7e0f7c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d7e0f7c"]])

export default __exports__